var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRdMemo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.438,
    height: 26.838,
    viewBox: "0 0 33.438 26.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.523 25.332a.907.907 0 0 0-.9-.011c-5.957 3.31-13.275 5.036-23.03 5.432a.907.907 0 0 0-.871.907v9.4a.907.907 0 0 0 .871.907c9.755.4 17.072 2.122 23.03 5.432a.908.908 0 0 0 1.348-.793V26.114a.906.906 0 0 0-.448-.782z",
    transform: "translate(-14.197 -25.207) translate(14.197 25.207) translate(-23.532 -25.207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.76 37.171a5.563 5.563 0 1 0 0 11.126.907.907 0 0 0 .908-.907v-9.311a.907.907 0 0 0-.908-.908z",
    transform: "translate(-14.197 -25.207) translate(14.197 25.207) translate(-14.197 -31.58)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.077 65.281a1.149 1.149 0 0 0-1.031-.778l-2.122-.1a1.148 1.148 0 0 0-1.149 1.5l1.905 6.228a1.148 1.148 0 0 0 1.092.794h2.2a1.149 1.149 0 0 0 1.058-1.6z",
    transform: "translate(-14.197 -25.207) translate(14.197 25.207) translate(-23.531 -46.083)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdMemo);
export default __webpack_public_path__ + "static/media/rd-memo.7ae4f5426d790bd44f6584cdd273ac2b.svg";
export { ForwardRef as ReactComponent };